import React from 'react';

import { AlineTextarea } from 'src/components';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  textArea: {
    '&:focus': {
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.appColors.primary}`,
    },
    '&:hover': {
      '&:focus': {
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.appColors.primary}`,
      },
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.appColors.rule}`,
    },
    backgroundColor: 'inherit',
    border: `1px solid ${theme.appColors.rule}`,
  },
}));

interface ReminderDescriptionProps {
  description: string;
  onDescriptionChange: (description: string) => void;
  editable?: boolean;
}

export function ReminderDescription({
  description,
  editable = true,
  onDescriptionChange,
}: ReminderDescriptionProps) {
  const { classes } = useStyles();

  return (
    <AlineTextarea
      className={classes.textArea}
      disabled={!editable}
      maxRows={5}
      minRows={5}
      placeholder="Add a description..."
      value={description}
      onChange={event => onDescriptionChange(event.target.value)}
    />
  );
}
